export default __webpack_public_path__ + "media/images/icons_fc/mail-a3b719eb45571a20842bec4c3a61d258.png";